import type { Produto } from "@/components/vitrine/types/produto.props"
export function getLinkProduto(produto: Produto): string {
    if (!produto?.link) return ''

    // link vem montado do backend agora
    return produto.link.startsWith('/') ? produto.link : `/${produto.link}`
}